export default __webpack_public_path__ + "static/media/table.65e42b81.jpg";